export default "__VITE_ASSET__BuMCFP____"